import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { CompanyScreen } from "../../screens/settings/CompanyScreen.tsx";

/** `/settings/company`: the company's name, address, language, time zone and currency. */
export const Route = createFileRoute("/_app/settings/company")({
  // exporting everything and closing the company is its own tab
  validateSearch: (search: Record<string, unknown>): { tab?: "export" } =>
    search.tab === "export" ? { tab: "export" as const } : {},
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("company.get", {})),
  component: CompanyScreen,
});
